import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "antd";

import TitleCard from "../../../components/HexCard/TitleCard";
import LinkPageHeader from "../../../components/LinkPageHeader";

import { getLabel } from "../../../hooks/use-labels";

import TotalInformationCard from "../ShoppingCart/CartDetailsView/TotalInformationCard";

import {
  getStorageItem,
  removeLocalStorageItems,
} from "../../../utils/common-utils";

import PaymentCard from "./PaymentMethodsCard";
import { getReservationExpiry } from "./PaymentMethodsCard/payment-utils";
import ReservationExpiryTimer from "./PaymentMethodsCard/ReservationExpiryTimer";

const OrderPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const reservation = getStorageItem("reservationInfo");

  const [reservationTimer, setReservationTimer] = useState(true);

  useEffect(() => {
    if (!reservation) {
      goBack();
    }

    return () => {
      removeLocalStorageItems("reservationInfo");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { link } = location.state || { link: "" };

  const goBack = () => {
    removeLocalStorageItems("reservationInfo");
    navigate(link.path, { state: link.previousState });
  };

  const toggleTimer = () => {
    setReservationTimer((prev) => !prev);
  };

  if (!reservation) return null;

  const { orderInfo } = reservation;

  return (
    <div className="content-container">
      <LinkPageHeader
        onBack={() => removeLocalStorageItems("reservationInfo")}
        className={"payment-page-title"}
        pageTitle={getLabel("paymentMethodsLabel")}
      />

      {reservationTimer && (
        <Row gutter={[20, 20]}>
          <Col lg={17} md={24} sm={24} xs={24} className="gutter-row">
            <ReservationExpiryTimer
              reservationExpiry={getReservationExpiry()}
              goBackToSummary={goBack}
            />
          </Col>
        </Row>
      )}

      <Row className="cart-details-container" gutter={[20, 20]}>
        <Col lg={17} md={24} sm={24} xs={24} className="gutter-row">
          <PaymentCard updateTimer={toggleTimer} />
        </Col>

        <Col lg={7} md={24} sm={24} xs={24} className="gutter-row">
          <TitleCard
            title={getLabel("orderDetailsLabel")}
            className={"first-card"}
          />

          <TotalInformationCard
            totalAmount={orderInfo.payableAmount}
            label={getLabel("payableAmountLabel")}
            className="last-card"
            borderless={true}
          />
        </Col>
      </Row>
    </div>
  );
};

export default OrderPayment;
